import { Button, Chip, Modal, ModalBody, ModalFooter, ModalHeader, Text } from '@change/ds-core-ui';
import { ExpandIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';

import { TopicsFilter } from 'src/app/pages/search/shared/components';

import { ClearTopicsFilter } from './components/ClearTopicsFilter';
import { useTopicsMobileButton } from './hooks/useTopicsMobileButton';

export const TopicsMobileButton: React.FC = () => {
	const {
		data: { nOfFilters, disabled },
	} = useTopicsMobileButton();

	return (
		<div className="relative">
			<Modal
				onClose={() => {}}
				trigger={
					<Chip
						as="button"
						trailingIcon={nOfFilters === 0 ? <ExpandIcon /> : undefined}
						active={nOfFilters > 0}
						size="small"
						count={nOfFilters > 0 ? nOfFilters : undefined}
						disabled={disabled}
					>
						<Translate value="corgi.search.filters.topic.title_chip" />
					</Chip>
				}
			>
				<ModalHeader
					title={
						<Text variant="heading" size="small">
							<Translate value="corgi.search.filters.topic.title" />
						</Text>
					}
				/>

				<ModalBody className="min-h-[50vh]">
					<TopicsFilter trackingContext="topic_filter" />
				</ModalBody>

				<ModalFooter>
					<Button variant="primary">
						<Translate value="corgi.search.filters.view_results" />
					</Button>
					<ClearTopicsFilter />
				</ModalFooter>
			</Modal>
		</div>
	);
};
